// @flow
import React from 'react';
import * as DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';

import type { PrevAndNextMatchesLinksType } from 'types/Rencontre';

type Props = {
  prevAndNextMatchesLinks: PrevAndNextMatchesLinksType
};

function PrevAndNextMatchesLinks({ prevAndNextMatchesLinks }: Props) {
  const prevMatchLink = prevAndNextMatchesLinks.prev_match.link;
  const prevMatchLabel = prevAndNextMatchesLinks.prev_match.label;

  const nextMatchLink = prevAndNextMatchesLinks.next_match.link;
  const nextMatchLabel = prevAndNextMatchesLinks.next_match.label;
  return (
    <div className="prev-next-pages mb-4">
      {!!prevMatchLink && !!prevMatchLabel && (
        <Link to={`${prevMatchLink}#nav-competition`} className="btn btn--cheer btn--white btn--left">
          <i className="icon icon-chevron-left link-icon is-inline" />
          <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(prevMatchLabel) }}></span>
        </Link>
      )}

      {!!nextMatchLink && !!nextMatchLabel && (
        <Link to={`${nextMatchLink}#nav-competition`} className="btn btn--cheer btn--white btn--right">
          <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(nextMatchLabel) }}></span>
          <i className="icon icon-chevron-right link-icon is-inline" />
        </Link>
      )}
    </div>
  );
}

export default PrevAndNextMatchesLinks;
